import React from 'react'
import ReactDOM from 'react-dom'
import videojs from 'video.js'

import { Forward15 } from 'images/bend'
import { SVGImage } from 'ui/bend'

const vjsComponent = videojs.getComponent('Button')

const SEEK_TIME = 15

class SeekForward extends vjsComponent {
  constructor(player) {
    super(player)

    this.state = {
      player
    }
    this.seek = this.seek.bind(this)

    player.ready(() => {
      this.mountElement()
    })

    /* Remove React root when component is destroyed */
    this.on('dispose', () => {
      ReactDOM.unmountComponentAtNode(this.el())
    })

    this.on('click', this.seek)
    // Handle touch events
    this.on('touchstart', this.seek)
  }

  mountElement() {
    ReactDOM.render(this.renderSeekerButton(), this.el())
  }

  seek() {
    const currentTime = this.state.player.currentTime()
    this.state.player.currentTime(currentTime + SEEK_TIME)
  }

  renderSeekerButton() {
    return (
      <SVGImage width='auto' height='20px' SVG={Forward15} alt='Forward15' />
    )
  }
}

vjsComponent.registerComponent('seekForward', SeekForward)

export default SeekForward
